import { render } from "./ProspectsWidget.vue?vue&type=template&id=95e96770"
import script from "./ProspectsWidget.vue?vue&type=script&lang=js"
export * from "./ProspectsWidget.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__